import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { FeatureFlag } from 'types/features';
import { useHasPermissions } from 'utils/permissionUtil';
import { useFeatureFlags } from 'utils/useFeatureFlags';

export interface ProtectedRouteProps {
    element: JSX.Element;
    redirectPath: string;
    permissions: string[];
    requiredFeature?: FeatureFlag;
}

export const ProtectedRoute = (props: ProtectedRouteProps): JSX.Element => {
    const { element, redirectPath, requiredFeature, permissions } = props;
    const { isFlowEnabled } = useFeatureFlags(requiredFeature);
    const hasPermissions = useHasPermissions(permissions);

    const hasAuthority = useMemo(() => isFlowEnabled && hasPermissions, [hasPermissions, isFlowEnabled]);

    if (hasAuthority) {
        return element;
    }

    return <Navigate to={redirectPath} replace />;
};
